import Select from "tether-select-nobower";

export default class extends Select{
  constructor({el}){
    super({
      el,
      className: 'select-theme-chosen',
    })
  }
}
